window.jQuery = window.$ = require('jquery');
require('jquery-validation');
require('./thirdParty/bootstrap');
require('./components/spinner');
var validator = require('./validator');
var populateErrorMessages = require('./validationMessage');
var processInclude = require('base/util');
var utils = require('./utils');
var debounce = require('lodash/debounce');
require('slick-carousel/slick/slick');
import clientSideRender from './clientSideRender';
var tealiumEnable;
var newsletterErrorMessages = {};

// This updates the webpack static path which enable async component loading
// eslint-disable-next-line no-underscore-dangle
__webpack_public_path__ = __staticPath__ + 'js/';

/**
 * set scrollbar width in css for drawer animation and avoid page shift
 */
function setScrollbarwidth() {
    const documentWidth = document.documentElement.clientWidth;
    const windowWidth = window.innerWidth;
    const scrollBarWidth = windowWidth - documentWidth;
    document.documentElement.style.setProperty('--scrollbarwidth', `${scrollBarWidth}px`);
}

/**
 * handle all data-toggle=modal to have animation in place.
 */
function handleModalAnimation() {
    $('body').on('show.bs.modal', '.modal-animated', function () {
        const $modal = $(this);

        $modal.on('hidePrevented.bs.modal', e => {
            utils.closeModal($modal, e);
        });

        $modal.on('hide.bs.modal', e => {
            utils.closeModal($modal, e);
        });
    });
}

/**
 * Handle Newsletter Email Validation
 * @param {string} fromId - Id of the newletter form
 * @param {string} registrationEmailId - Id of the email field
 */
function newsletterEmailError(fromId, registrationEmailId) {
    var $newsletterForm = $(fromId);
    var $subscribeEmail = $newsletterForm.find(registrationEmailId);
    populateErrorMessages(newsletterErrorMessages, $subscribeEmail);
    validator.init($newsletterForm, {
        ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
        ...validator.ENABLED_BUTTON_SETTINGS,
        messages: newsletterErrorMessages
    });
}

/**
 * Function to show or validate error msg on submit of newsletter form
 * @param {Object} data - data coming from response on submit
*/
function showErrorMsgOnNewsletter(data, modalContainer = '') {
    var hideNewsletterTime = $('.global-footer').data('hidenewslettertime');
    if (data.error) {
        // eslint-disable-next-line no-useless-concat
        $(modalContainer + ' ' + '.newsletter-error-msg').html(`<svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg><div class="error-msg-text">${data.errorMsg}</div>`);
        return;
    }
    if (data.alreadySubscribed === 'false') {
        $('.form-column').addClass('d-none');
        $('.thanks-column').removeClass('d-none');
        setTimeout(() => {
            $('#pvh-newsletter-subs').modal('hide');
            $('#pvh-newsletter-subs-modal').length > 0 && $('#pvh-newsletter-subs-modal').modal('hide');
        }, hideNewsletterTime);
    } else if (data.alreadySubscribed === 'true') {
        $(modalContainer + ' ' + '.newsletter-error-msg').html(`<svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg>${data.errorMsg}`);
    }
}

function getModalHtmlElement(modalId) {
    const $modalContainer = $(`#${modalId}.modal`);
    if ($modalContainer.length !== 0) {
        $modalContainer.remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="' + modalId + '" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog modal-dialog-centered">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-body"></div>' +
        '<div></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Function to update PageViewCount of user
 * @param {Object} visits - update number of visits for cookies setup
 * @returns {Object} visits
*/
function updateVisitCount(visits) {
    var maxPageViews = $('.global-footer').data('newsletterloadvalue');
    if (visits < maxPageViews) {
        return visits + 1;
    } else if (visits === maxPageViews) {
        return 0;
    }
    return 0;
}

/**
 * Function to show newsletter modal
 */
function newsletterModalOpen() {
    $.spinner().start();
    var newsLetterModalUrl = $('.newsletter-footer-btn .newsletter-sub-btn').attr('data-url');
    $.ajax({
        url: newsLetterModalUrl,
        type: 'get',
        success: function (data) {
            getModalHtmlElement('pvh-newsletter-subs-modal');
            $('#pvh-newsletter-subs-modal .modal-body').html(data);
            $('#pvh-newsletter-subs-modal').modal('show');
            $('#pvh-newsletter-subs-modal').data('emailSignUpLocation', 'pop up modal');
            newsletterEmailError('#emailOptinForm', '#registration-form-email');
            $('#emailOptinFormModal').length > 0 && newsletterEmailError('#emailOptinFormModal', '#registration-form-email-modal');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function newsLetterHandler() {
    var isNewsletterEnable = $('.global-footer').data('isnewsletterenabled');
    var includeoverlay = $('.includeOverlay').data('includeoverlay');
    var includeExcludedPageCount = $('.includeOverlay').data('include-excluded-page-count');
    if (isNewsletterEnable) {
        if (!cookieSet.get('pageViewCount') && !cookieSet.get('newsletterModalShown') && includeoverlay) {
            cookieSet.set('pageViewCount', 1);
        } else if (!cookieSet.get('pageViewCount') && !cookieSet.get('newsletterModalShown') && includeExcludedPageCount) {
            cookieSet.set('pageViewCount', 1);
        }
        var currentPageViewCount = cookieSet.get('pageViewCount');
        var isNewsletterIgnored = cookieSet.get('newsletterModalShown');
        var pageViewCount = currentPageViewCount;
        if (!includeExcludedPageCount && includeoverlay) {
            pageViewCount = updateVisitCount(parseInt(currentPageViewCount, 10));
        } else if (includeExcludedPageCount) {
            pageViewCount = updateVisitCount(parseInt(currentPageViewCount, 10));
        }
        if (pageViewCount !== 0) {
            cookieSet.set('pageViewCount', pageViewCount);
        } else if (!isNewsletterIgnored && includeoverlay) {
            newsletterModalOpen();
            cookieSet.delete('pageViewCount');
            cookieSet.set('newsletterModalShown', 1);
        }
    }
}

function submitNewsletterForm() {
    $(document).on('submit', 'form#emailOptinForm', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var url = $('#emailOptinFormBtn').data('url');
        var emailSignUpLocation = $('#pvh-newsletter-subs-modal').data('emailSignUpLocation');
        if ($(this).parents('.ds-footer-join-club').length) {
            emailSignUpLocation = 'embedded email form in footer';
        }
        var email = $('input#registration-form-email-footer');
        email.val($.trim(email.val()));
        if ($('#add-to-email-list').is(':checked')) {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $('form#emailOptinForm').serialize(),
                success: function (data) {
                    showErrorMsgOnNewsletter(data);
                    if (data.alreadySubscribed === 'false') {
                        tealiumEnable.getAnalyticsData('emailOptInTracking', emailSignUpLocation, data.email);
                    }
                },
                error: function (err) {
                    if ('responseJSON' in err) {
                        showErrorMsgOnNewsletter(err.responseJSON);
                    }
                }
            });
        } else {
            $('form#emailOptinForm .check-box-error').removeClass('d-none');
        }
    });

    $(document).on('submit', 'form#emailOptinFormModal', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var url = $('#emailOptinFormBtn').data('url');
        if ($('#add-to-email-list-modal').is(':checked')) {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $('form#emailOptinFormModal').serialize(),
                success: function (data) {
                    showErrorMsgOnNewsletter(data, '#emailOptinFormModal');
                    if (data.alreadySubscribed === 'false') {
                        var emailSignUpLocation = $('#pvh-newsletter-subs-modal').data('emailSignUpLocation');
                        tealiumEnable.getAnalyticsData('emailOptInTracking', emailSignUpLocation, data.email);
                    }
                }
            });
        } else {
            $('form#emailOptinFormModal .check-box-error').removeClass('d-none');
        }
    });

    $(document).on('click', '#add-to-email-list', function () {
        if ($(this).is(':checked')) {
            $('form#emailOptinForm .check-box-error').addClass('d-none');
        }
    });

    $(document).on('click', '#add-to-email-list-modal', function () {
        if ($(this).is(':checked')) {
            $('form#emailOptinFormModal .check-box-error').addClass('d-none');
        }
    });
}


// eslint-disable-next-line no-undef
$(function () {
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/customerService'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/notification'));

    tealiumEnable = require('int_tealium_sfra/tealiumEnable');
    newsLetterHandler();
    submitNewsletterForm();

    $(document).on('ftr:customerWebIdReady', function (e, webId) {
        window.sessionStorage.removeItem('webId');
        $('#webiddesk').html('Web ID: ' + webId);
        $('#webidmob').html('Web ID: ' + webId);
        window.sessionStorage.setItem('webId', webId);
    });

    setScrollbarwidth();
    utils.setWindowHeight();
    window.addEventListener('resize', debounce(() => {
        utils.setWindowHeight();
        $('body').trigger('window:resized');
        setScrollbarwidth();
    }), 20);

    handleModalAnimation();
    utils.toggleInteractionMode();
    clientSideRender.mountAllComponents();
    $('body').on('component:updated', (event, component, id) => {
        clientSideRender.mountComponent(component, id);
    });

    // add no touch class for devices which support no touch. used for styling
    if (!utils.isTouchEnabled()) {
        $('html').addClass('no-touch');
    }

    // A global logic to reset PLP pos if user navigated anywhere else from PLP other than PDP
    // included search to prevent from deleted position, it will be deleted in searchjs after scrolling
    if (!['product', 'search'].includes(utils.getCurrentPageName()) && utils.plpScrollPosExists()) {
        // remove PLP scroll pos
        utils.resetPLPScrollPos();
    }
});

// Handle the broken image error.
window.onImageError = utils.onImageError;

// redefine cookieset
window.cookieSet = utils.cookieSet();
